import { Component, input, inject } from '@angular/core';
import { I18nService } from '@lp-ui-lib';
import { AssetsService } from '@lp-ui-lib';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-sensor-health-status',
  imports: [NzIconModule],
  templateUrl: './sensor-health-status.html',
  styleUrl: './sensor-health-status.scss',
})
export class SensorHealthStatus {
  private assetService = inject(AssetsService);
  public i18n = inject(I18nService);

  rotatingEqWorkingFine = input(this.assetService.rotatingEqWorkingFineSig());
  rotatingEqCritical = input(this.assetService.rotatingEqCriticalSig());
  rotatingEqWarning = input(this.assetService.rotatingEqWarningSig());
  rotatingEqInactive = input(this.assetService.rotatingEqInactiveSig());
}
